import { renderICD10 } from "./render-ICD10";

export const getSignatureFields = (note) => {
  return (
    <>
      <div className="col-12 col-lg-6 mt-3">
        <div>
          <label className="Label">ICD-10 Primary Diagnosis</label>
          <div>
            {note.ICD_10_axis_1_diagnosis ? (
              <ul>{renderICD10(note.ICD_10_axis_1_diagnosis)}</ul>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6 mt-3">
        <div>
          <label className="Label">ICD-10 Secondary Diagnosis</label>
          <div>
            {note.ICD_10_axis_2_diagnosis ? (
              <ul>{renderICD10(note.ICD_10_axis_2_diagnosis)}</ul>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};
